
import { useState } from "react";
import Modal from "../../../myfin_v2/elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { Button } from "../../../myfin_v2/elements/Button";
import commoncss from "../../../myfin_v2/css/common.module.css";
import FilterRow from "../../../myfin_v2/components/bookclosure/FilterRow";




const FilterModal = ({ filterAttr, handleClose }) => {

    const [filterRows, setFilterRows] = useState([{}]);



    const addFilter = () => {
        setFilterRows((prev) => [...prev, {}]);
    };

    const removeFilterRow = (indexToRemove) => {
        setFilterRows((prev) => prev.filter((_, i) => i !== indexToRemove));
    };

    const clearAllFilters = () => {
        setFilterRows([]);
        setTimeout(() => addFilter(), 0);
        // setBookClosureFilterModal(false);
    };

    const updateFilterRow = (index, updated) => {
        setFilterRows((prev) => {
            return prev.map((row, i) => {
                if (i === index) {
                // Only update the row if `updated` is a valid object or a function.
                // If it's a function, call it with the current row
                    return typeof updated === "function"
                        ? updated(row)
                        : { ...row, ...updated };
                    }
                return row;
            });
        });
    };



    return (
        <Modal
            width="45%"
            minHeight={"350px"}
            title="Filters"
            bodycss={commoncss.unsetPadding}
            headerActions={
                <>

                    {filterRows.length > 0 && (
                        <label
                            className={`${commoncss.textLabel} ${commoncss.fs15} ${commoncss.clickable}`}
                            onClick={clearAllFilters}
                        >
                            Reset All
                        </label>
                    )} 
                </>
            }
            onClose={() => console.log("Modal Closed")}
            footerActions={
                <>
                    <Button
                        btnColor={buttoncss.secondary}
                        onClick={handleClose}
                        label="Cancel"
                    />
                    <span>
                        <Button
                            btnColor={buttoncss.secondary}
                            label="Add Filter"
                            onClick={addFilter}
                        />
                        &ensp;
                        <Button
                            btnColor={buttoncss.primary}
                            label="Apply Filter"
                        />
                    </span>
                </>
            }
        >

            <div className={commoncss.pd1530}>
                {filterRows.map((_, index) => (
                    <>
                        <span className="input-label mt-1">&nbsp;Where</span>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <FilterRow
                                key={index}
                                onChange={(data) => updateFilterRow(index, data)}
                                filterAttr={filterAttr}
                                onRemove={() => removeFilterRow(index)}
                            />
                        </div>
                    </>
                ))}
            </div>

        </Modal>
    )

}

export default FilterModal;